// File: src/components/profile/Profile.js
// Purpose: User profile page - converted to functional component with RTK
// Last modified: 2025-11-06

import './profile.scss';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MobileNavigation from '../BottomNavigation';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ReactLoading from 'react-loading';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AdBanner from '../ads/AdBanner';
import { selectUser } from '../../store/slices/userSlice';
import apiService from '../../services/api';

function isValidEmailAddress(address) {
    return !! address.match(/.+@.+/) && address.indexOf('.') > -1;
}

const Profile = ({ expiredLogin = false }) => {
    const user = useSelector(selectUser);

    const [email, setEmail] = useState('');
    const [error, setError] = useState(false);
    const [emailIsValid, setEmailIsValid] = useState(false);
    const [emailIsSent, setEmailIsSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleLogout = async () => {
        try {
            await apiService.auth.logout();
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } catch (error) {
            console.error('Cannot log out:', error);
        }
    };

    const handleEmailLoginButton = async () => {
        if (email === '' || email.indexOf('@') < 0 || email.indexOf('.') < 0) {
            return;
        }

        setLoading(true);

        try {
            await apiService.auth.requestLoginToken(email);
            setLoading(false);
            setEmailIsSent(true);
        } catch (error) {
            setError(true);
            setLoading(false);
        }
    };

    // If user is not logged in, show login form
    if (!user.name || expiredLogin) {
        return (
            <div className={'profile-container'}>
                {loading && (
                    <div className={'loading'}>
                        <ReactLoading
                            type={'spin'}
                            color={'#838383'}
                            height={'20%'}
                            width={'20%'}
                        />
                    </div>
                )}
                <div className={'login-container'}>
                    {expiredLogin && (
                        <div className={'icon-container'}>
                            <ErrorOutlineIcon className={'error-icon'} />
                        </div>
                    )}
                    {expiredLogin && (
                        <div style={{marginBottom: '30px', textAlign: 'center'}}>
                            Sizning email orqali yuborilgan login havolasi muddati tugagan yoki yaroqsiz.
                            Iltimos, qaytadan login qilish uchun quyidagi usullardan birini tanlang.
                        </div>
                    )}
                    {!expiredLogin && (
                        <div style={{marginBottom: '30px', textAlign: 'center'}}>
                            Hali ro'yxatdan o'tmadingiz, iltimos quyidagi veb-servislardan foydalangan holda avtorizatsiyadan oʼtishingiz lozim:
                        </div>
                    )}

                    <div className='oauth2-option'>
                        <a href={apiService.auth.getOAuthUrls().google} className='google'>
                            <img
                                src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0xNy42NCA5LjIwNWMwLS42MzktLjA1Ny0xLjI1Mi0uMTY0LTEuODQxSDl2My40ODFoNC44NDRhNC4xNCA0LjE0IDAgMCAxLTEuNzk2IDIuNzE2djIuMjU5aDIuOTA4YzEuNzAyLTEuNTY3IDIuNjg0LTMuODc1IDIuNjg0LTYuNjE1eiIgZmlsbD0iIzQyODVGNCIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+PHBhdGggZD0iTTkgMThjMi40MyAwIDQuNDY3LS44MDYgNS45NTYtMi4xOGwtMi45MDgtMi4yNTljLS44MDYuNTQtMS44MzcuODYtMy4wNDguODYtMi4zNDQgMC00LjMyOC0xLjU4NC01LjAzNi0zLjcxMUguOTU3djIuMzMyQTguOTk3IDguOTk3IDAgMCAwIDkgMTh6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD48cGF0aCBkPSJNMy45NjQgMTAuNzFBNS40MSA1LjQxIDAgMCAxIDMuNjgyIDljMC0uNTkzLjEwMi0xLjE3LjI4Mi0xLjcxVjQuOTU4SC45NTdBOC45OTYgOC45OTYgMCAwIDAgMCA5YzAgMS40NTIuMzQ4IDIuODI3Ljk1NyA0LjA0MmwzLjAwNy0yLjMzMnoiIGZpbGw9IiNGQkJDMDUiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPjxwYXRoIGQ9Ik05IDMuNThjMS4zMjEgMCAyLjUwOC40NTQgMy40NCAxLjM0NWwyLjU4Mi0yLjU4QzEzLjQ2My44OTEgMTEuNDI2IDAgOSAwQTguOTk3IDguOTk3IDAgMCAwIC45NTcgNC45NThMMy45NjQgNy4yOUM0LjY3MiA1LjE2MyA2LjY1NiAzLjU4IDkgMy41OHoiIGZpbGw9IiNFQTQzMzUiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPjxwYXRoIGQ9Ik0wIDBoMTh2MThIMHoiPjwvcGF0aD48L2c+PC9zdmc+'
                                height='20' width='20'
                            />
                            <span>Google</span>
                        </a>
                    </div>
                    {!emailIsSent && (
                        <div className='oauth2-option'>
                            <div className='email'>
                                <input
                                    type="email"
                                    placeholder={'Email'}
                                    value={email}
                                    onChange={(event) => {
                                        setEmail(event.target.value);
                                        setEmailIsValid(isValidEmailAddress(event.target.value));
                                    }}
                                    onBlur={() => setEmailIsValid(isValidEmailAddress(email))}
                                />
                                <ArrowCircleRightIcon
                                    className={emailIsValid ? 'valid' : 'invalid'}
                                    onClick={() => handleEmailLoginButton()}
                                />
                            </div>
                        </div>
                    )}

                    {emailIsSent && (
                        <div className='oauth2-option'>
                            <p>Sizga email yuborildi, iltimos elektron pochtangizni tekshiring - {email}</p>
                        </div>
                    )}
                    <div style={{color: '', marginTop: '20px', fontSize: '15px', textAlign: 'center'}}>
                        Sahifamizdan foydalanishingiz, <a href={`${process.env.REACT_APP_API_URL}/privacy-policy`} target='_blank' rel='noreferrer'>Foydalanish shartlari</a> va <a href={`${process.env.REACT_APP_API_URL}/privacy-policy`} target='_blank' rel='noreferrer'>Maxfiylik siyosati</a> shartlarini qabul qilganingizni anglatadi
                    </div>
                </div>
                {!expiredLogin && (
                    <div className={'back-root-domain'}>
                        <a href={`${process.env.REACT_APP_API_URL}`}>
                            Eski ko'rinishga qaytish <ArrowCircleRightIcon/>
                        </a>
                    </div>
                )}
                <MobileNavigation/>
            </div>
        );
    }

    // User is logged in - show profile
    return (
        <div className={'profile-container'}>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={9} md={9}>
                        <h2>Mening profilim</h2>
                    </Grid>
                    <Grid
                        item xs={3} md={3}
                        onClick={handleLogout}
                        className={'logout'}
                        style={{display: 'flex', justifyContent: 'right', alignItems: 'center', cursor: 'pointer'}}
                    >
                        <ExitToAppIcon/>
                    </Grid>
                    <Grid item xs={16} md={16}>
                        <ul>
                            <li>Ism: {user.name}</li>
                            <li>Email: {user.email}</li>
                            <li>A'zolik sanasi: {user.created}</li>
                        </ul>
                    </Grid>
                    <Grid item xs={16} md={16}>
                        <AdBanner
                            variant="card"
                            dismissible={true}
                            storageKey="zakovat_profile_ad"
                            expiryDays={3}
                        />
                    </Grid>
                </Grid>
            </Container>

            <div className={'back-root-domain'}>
                <a href={`${process.env.REACT_APP_API_URL}/?activateWebApp=false`}>
                    Eski ko'rinishga qaytish <ArrowCircleRightIcon/>
                </a>
            </div>
            <MobileNavigation/>
        </div>
    );
};

export default Profile;
